import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import Img from 'gatsby-image';

import Banner from '../img/farm-field.jpg';
import MainBuilding from '../img/main_building.jpg';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default () => {
  const data = useStaticQuery(graphql`
    query {
      Banner: file(relativePath: { eq: "farm-field.jpg" }) {
        childImageSharp {
          # Specify a fluid image and fragment
          # The default maxWidth is 800 pixels
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      MainBuilding: file(relativePath: { eq: "main_building.jpg" }) {
        childImageSharp {
          # Specify a fluid image and fragment
          # The default maxWidth is 800 pixels
          fluid(maxWidth: 480) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  return (
    <div className="antialiased text-gray-900 min-h-screen flex flex-col">
      <Navbar />
      <div style={{ height: '19rem' }}>
        <Img
          fluid={data.Banner.childImageSharp.fluid}
          className="h-full w-full object-cover"
          imgStyle={{ objectPosition: '50% 62%' }}
        />
      </div>
      <main className="flex-grow">
        <div className="max-w-screen-md mx-auto mb-12 px-12">
          <h1 className="text-center font-bold text-4xl mt-4">About Apogee</h1>
          <div className="my-8">
            <div className="my-2">
              <h2 className="leading-tight">
                <strong>Apogee &ndash; Climate & Energy Transitions</strong> is
                a program of Earth Tools Inc.
              </h2>
              <Img
                fluid={data.MainBuilding.childImageSharp.fluid}
                className="float-right w-1/2 ml-4 mt-3"
              />
              <p>
                Earth Tools Inc. is a small business in Owen County, Kentucky,
                that sells and services walk-behind tractors, implements and
                hand tools to small farmers and gardeners throughout North
                America. Since its founding in 1998, Earth Tools has been
                committed to supporting healthy communities and environmental
                sustainability.
              </p>
              <h2>Before Apogee</h2>
              <p>
                In 2013, Earth Tools established our Sustainable Systems
                Program, expanding our services to include solar energy, energy
                efficiency, and sustainable living. The Sustainable Systems
                Program has helped us make our own operations more sustainable,
                while also serving customers in central Kentucky. For example,
                we have combined energy conservation and efficiency measures
                with solar photovoltaics to meet most of our net annual
                electricity needs. Following an expansion of our solar PV system
                in 2020, we expect to reach net-zero electricity.
              </p>
              <p>
                To learn more about sustainability at Earth Tools,{' '}
                <Link href="/sustainability-at-earth-tools/">visit here</Link>.
              </p>
              <h2>A Mission-Driven Business</h2>
              <p>
                At Earth Tools, we believe in using our gifts to work for a
                better world. Our business serves our values and we support
                projects and organizations working for environmental protection
                and ecological restoration, healthy communities, and
                sustainability. We recognize the urgency of the climate crisis;
                that our local and global communities, along with the natural
                world and the diversity of life, are all threatened by climate
                change. We recognize the need to rapidly transition our economy
                away from fossil fuels.
              </p>
              <h2>Founding Apogee</h2>
              <p>
                In 2020, we established Apogee to focus on this critical
                societal need and the opportunities that accompany the energy
                transition. Apogee is committed to working in the public
                interest and for the common good. All revenue earned by Apogee
                is used to support our mission, which is to advance the
                transition to 100% clean renewable energy and solutions to the
                climate crisis. We do this through technical assistance,
                education, policy research, and advocacy in collaboration with a
                wide range of partners.
              </p>
              <div className="border-4 rounded-lg pt-4 pb-6 px-4 mt-6 border-apogee-blue">
                <div className="text-xl">
                  <strong>apogee</strong> <strong>[ a</strong> &ndash; poh
                  &ndash; jee ]
                </div>
                <div>
                  <em>noun</em>
                </div>{' '}
                <ol className="list-decimal list-inside">
                  <li>
                    the point in the path of an object orbiting the Earth that
                    is at its greatest distance from the Earth.
                  </li>
                  <li>the farthest or highest point, apex.</li>
                </ol>
                <p>
                  The Intergovernmental Panel on Climate Change has warned that
                  limiting global warming to 1.5&deg; C is critical if we are to
                  minimize the catastrophic effects of climate change. To
                  achieve this, global carbon emissions must peak and begin a
                  rapid decline before the end of this decade, ultimately
                  reaching zero net emissions by mid-century.{' '}
                  <strong>
                    The apogee of our carbon emissions must be reached within
                    the next decade.
                  </strong>
                </p>
                <p>
                  *See{' '}
                  <a href="https://www.ipcc.ch/sr15/">
                    Global Warming of 1.5&deg; C: A Special Report
                  </a>
                  , 2018, Intergovernmental Panel on Climate Change*
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
